namespace TabAurous.Sales {
    export namespace SalesItemsService {
        export const baseUrl = 'Sales/SalesItems';

        export declare function Create(request: Serenity.SaveRequest<SalesItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CategoryList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubCategoryList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/SalesItems/Create",
            Update = "Sales/SalesItems/Update",
            Delete = "Sales/SalesItems/Delete",
            Retrieve = "Sales/SalesItems/Retrieve",
            List = "Sales/SalesItems/List",
            CustomList = "Sales/SalesItems/CustomList",
            ProductList = "Sales/SalesItems/ProductList",
            CategoryList = "Sales/SalesItems/CategoryList",
            SubCategoryList = "Sales/SalesItems/SubCategoryList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'ProductList', 
            'CategoryList', 
            'SubCategoryList'
        ].forEach(x => {
            (<any>SalesItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
